import React from "react";
import {
  BrowserRouter,
  HashRouter,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";

import { useEffect } from "react";
import Dashboard from "./pages/Dashboard";
import Mainlayout from "./components/Mainlayout";
import OrderInfo from "./pages/OrderInfo";
import Menu from "./pages/Menu";
import AddCategory from "./pages/menu/category/AddCategory";
import CategoryList from "./pages/menu/category/CategoryList";
import Restaurants from "./pages/Restaurants";
import Login from "./pages/Login";
import { get_token_data } from "./components/utility/Get_token_data";
import { useDispatch, useSelector } from "react-redux";
import { get_category_data } from "./redux/Category/CategorySlice";
import AddRestaurant from "./pages/restaurant/AddRestaurant";
import { get_restarent_data } from "./redux/Restaurant/RestaurantSlice";
import { get_subcategory_data } from "./redux/Subcategory/SubcategorySlice";
import AddSubcategory from "./pages/menu/subcategory/AddSubcategory";
import RestaurantInfo from "./pages/RestaurantInfo";
import Orders from "./pages/Orders";
import Promotions from "./pages/Promotions";
import User from "./pages/User";
import SubAdmin from "./pages/SubAdmin";
import AdminPermission from "./pages/AdminPermission";
import Reports from "./pages/Reports";
import Accounting from "./pages/Accounting";
import SubcategoryList from "./pages/menu/subcategory/SubcategoryList";
import UpdateSubcategory from "./pages/menu/subcategory/UpdateSubcategory";
import MenuAdd from "./pages/menu/menu/MenuAdd";
import UpdateMenu from "./pages/menu/menu/UpdateMenu";
import ListMenu from "./pages/menu/menu/ListMenu";
import AddProducts from "./pages/menu/products/AddProducts";
import ListProduct from "./pages/menu/products/ListProduct";
import UpdateProduct from "./pages/menu/products/UpdateProduct";
import { get_restaurant_add_ons } from "./redux/add_ons/AddOnsSlice";
import Create_delivery_partner from "./pages/delivery_partner/Create_delivery_partner";

const App = () => {
  const dispatch = useDispatch();

  const { category_all, category_allLoading, isCategory_allAvailable } =
    useSelector((store) => store.category);
  const { restaurant_all, restaurant_allLoading, isrestaurant_allAvailable } =
    useSelector((store) => store.restaurant);
  const {
    sub_category_all,
    sub_category_allLoading,
    issub_Category_allAvailable,
  } = useSelector((store) => store.subcategory);
  
  const { add_ons_all, add_ons_allLoading, isadd_ons_allAvailable } =
    useSelector((store) => store.addons);

  useEffect(() => {
    if (!isCategory_allAvailable || category_all.length === 0) {
      dispatch(get_category_data());
    }
    if (!isrestaurant_allAvailable || restaurant_all.length === 0) {
      dispatch(get_restarent_data());
    }
    if (!issub_Category_allAvailable || sub_category_all.length === 0) {
      dispatch(get_subcategory_data());
    }
    if (!isadd_ons_allAvailable || add_ons_all.length === 0) {
      dispatch(get_restaurant_add_ons("6703ad1f8645725a27441b26"));
    }
  }, []);

  useEffect(() => {
    const timeout = setTimeout(async () => {
      if (category_allLoading) {
        dispatch(get_category_data());
      }
      if (restaurant_allLoading) {
        dispatch(get_restarent_data());
      }
      if (sub_category_allLoading) {
        dispatch(get_subcategory_data());
      }
      if (add_ons_allLoading) {
        dispatch(get_restaurant_add_ons("6703ad1f8645725a27441b26"));
      }
    }, 20000);
  }, []);

  return (
    <>
      <div>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/admin" exact element={<Mainlayout />}>
              <Route index element={<Dashboard />} />

              <Route path="/admin/order-info" element={<OrderInfo />} />

              <Route path="/admin/menu" element={<Menu />} />

              <Route path="/admin/add-category" element={<AddCategory />} />
              <Route path="/admin/list-category" element={<CategoryList />} />

              <Route path="/admin/menu-add" element={<MenuAdd />} />
              <Route path="/admin/menu-list" element={<ListMenu />} />
              <Route
                path="/admin/update-menu/:menu_id"
                element={<UpdateMenu />}
              />

              <Route
                path="/admin/add-subcategory"
                element={<AddSubcategory />}
              />
              <Route
                path="/admin/list-subcategory"
                element={<SubcategoryList />}
              />
              <Route
                path="/admin/update-subcategory/:subcatslugurl"
                element={<UpdateSubcategory />}
              />

              <Route path="/admin/product-add" element={<AddProducts />} />
              <Route path="/admin/product-list" element={<ListProduct />} />
              <Route
                path="/admin/product-update/:product_url"
                element={<UpdateProduct />}
              />

              <Route path="/admin/restaurants" element={<Restaurants />} />
              <Route path="/admin/add-restaurant" element={<AddRestaurant />} />
              <Route
                path="/admin/restaurant-info"
                element={<RestaurantInfo />}
              />
              <Route path="/admin/orders" element={<Orders />} />

              <Route path="/admin/promotions" element={<Promotions />} />

              <Route path="/admin/user" element={<User />} />

              <Route path="/admin/sub-admin" element={<SubAdmin />} />
              <Route
                path="/admin/admin-permission"
                element={<AdminPermission />}
              />

              <Route path="/admin/reports" element={<Reports />} />
              <Route path="/admin/accounts" element={<Accounting />} />

              <Route
                path="/admin/partner-create"
                element={<Create_delivery_partner />}
              />
              

            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </>
  );
};

export default App;
